var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9599 3.50352C22.8504 3.39458 22.7122 3.31916 22.5613 3.28612C22.4105 3.25307 22.2533 3.26379 22.1084 3.31699L4.26691 9.8048C4.11304 9.86316 3.98057 9.96695 3.88709 10.1024C3.79361 10.2378 3.74355 10.3985 3.74355 10.5631C3.74355 10.7276 3.79361 10.8883 3.88709 11.0237C3.98057 11.1592 4.11304 11.263 4.26691 11.3213L11.2332 14.103L16.3748 8.94516L17.5183 10.0886L12.3523 15.2546L15.1421 22.2208C15.2022 22.3717 15.3062 22.5011 15.4407 22.5922C15.5752 22.6833 15.7339 22.7319 15.8963 22.7317C16.0602 22.7284 16.2192 22.6754 16.3524 22.5799C16.4856 22.4843 16.5867 22.3507 16.6424 22.1965L23.1302 4.35504C23.1855 4.21156 23.1988 4.05533 23.1686 3.90456C23.1385 3.7538 23.0661 3.61471 22.9599 3.50352Z",
    fill: "#24B0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.7cae41a6384dc44f26ca25c0a971d9dd.svg";
export { ForwardRef as ReactComponent };